<label *ngFor="let value of filter.options" class="panel-block checkbox">
    <input type="checkbox" [checked]="values[value]" (change)="onFilterChange($event, value)"> {{value}}
</label>
